import { DataSource, Layout, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutRenditionOverrideProfiles extends Layout {
    sourceRenditionDocumentProfiles: DataSource;
    sourceRenditionEmailProfiles: DataSource;
    sourceRenditionFaxProfiles: DataSource;
    sourceRenditionFilterProfs: DataSource;
    sourceRenditionOverrideProfiles: DataSource;
    sourceRenditionOverrideProfs: DataSource;
    sourceRenditionRuleProfiles: DataSource;
    tbFiltDesc: Textbox;
    tbFiltExprsn: Textbox;
    tbFiltId: Textbox;
    tbOvrdSeq: Textbox;
    tbOvrhDesc: Textbox;
    tbOvrhId: Textbox;
    textboxDocpId: Textbox;
    textboxEmailpId: Textbox;
    textboxFaxpId: Textbox;
    textboxFiltDesc2: Textbox;
    textboxFiltDesc: Textbox;
    textboxFiltExprsn: Textbox;
    textboxOvrdDocp: Textbox;
    textboxOvrdEmailp: Textbox;
    textboxOvrdFaxp: Textbox;
    textboxOvrdFilterid: Textbox;
    textboxOvrdId: Textbox;
    textboxOvrdProcess: Textbox;
    textboxOvrdRulep: Textbox;
    textboxOvrdSeq: Textbox;
    textboxOvrhDesc: Textbox;
    textboxRulepId: Textbox;
}
